export function initialize(module: ng.IModule) {
    module.directive("list", list);
}

function list(): ng.IDirective {
    return {
        scope: {
            items: "=",
            filterBy: "@",
            displayName: "@",
            showSearch: "=",
            detailsState: "@"
        },
        restrict: "A",
        template: require("./list.directive.html")
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/list.directive.ts